import { Check } from 'lucide-react';
import { X } from 'lucide-react';
import { tv } from 'tailwind-variants';

const passwordRuleItemClasses = tv({
  slots: {
    container: 'flex items-start gap-4',
    icon: 'size-5 flex-shrink-0 mt-1.5',
    text: 'p5',
  },
  variants: {
    state: {
      checked: {
        icon: 'text-cyan',
        text: 'text-cyan',
      },
      unchecked: {
        icon: 'text-secondary fill-current',
        text: 'text-secondary',
      },
      error: {
        icon: 'text-destructive',
        text: 'text-destructive',
      },
    },
  },
  defaultVariants: {
    state: 'unchecked',
  },
});

type Props = {
  password: string | undefined;
  passwordChecks: Array<string>;
  unmetPasswordChecks: Array<string>;
  isFormSubmitted: boolean;
};

const PasswordRulesList = ({
  password,
  passwordChecks,
  unmetPasswordChecks,
  isFormSubmitted,
}: Props) => {
  return (
    <div className="space-y-4">
      {passwordChecks.map(check => {
        const isValid = password && !unmetPasswordChecks.includes(check);

        const state = isValid
          ? 'checked'
          : isFormSubmitted
            ? 'error'
            : 'unchecked';

        const { container, icon, text } = passwordRuleItemClasses({
          state,
        });

        const IconComponent = isValid ? Check : X;

        return (
          <div key={check} className={container()}>
            <IconComponent className={icon()} />
            <span className={text()}>{check}</span>
          </div>
        );
      })}
    </div>
  );
};

export { PasswordRulesList };
